export const copy = {
  "zh-CN": {
    kicker: "亚洲体育 · 电竞 · 娱乐资讯",
    heroLine1: "亚洲体育",
    heroLine2: "与娱乐指南",
    heroTags: "足球 · 篮球 · 电竞 · 线上娱乐",
    heroDesc: "聚合亚洲体育、电竞与线上娱乐内容，快速了解近期热门资讯与合作平台信息。",
    valueLine: "体育 · 电竞 · 娱乐内容一站了解",
    tag1: "足球 · 篮球",
    tag2: "电竞动态",
    tag3: "线上娱乐",
    ctaGo: "进入娱乐平台",
    ctaHelper: "了解第三方体育与线上娱乐内容",
    ctaNote: "将前往第三方合作平台",
    regionNotice: "第三方服务可用性因地区、年龄及当地法规而异",
    valueHeading: "热门内容",
    v1Title: "线上娱乐",
    v1Desc: "多元线上娱乐内容与最新动态",
    v2Title: "足球",
    v2Desc: "赛事资讯 · 球队动态",
    v3Title: "篮球",
    v3Desc: "赛事资讯 · 球员动态",
    v4Title: "电竞",
    v4Desc: "电竞赛事 · 战队资讯",
    bridgeLine: "从体育赛事、电竞竞技到线上娱乐内容，快速了解不同内容类型，并查看相关第三方合作平台信息。",
    seeHeading: "你可以在ASG看到什么",
    seeSub: "从赛事动态到数字娱乐，一站了解体育、电竞与线上娱乐内容。",
    scope1: "足球赛事",
    scope2: "篮球动态",
    scope3: "电竞竞技",
    s1Title: "赛事互动",
    s1Desc: "赛程、对阵、比赛动态与互动内容",
    s2Title: "数字竞技",
    s2Desc: "电竞赛事、竞技内容与数字娱乐动态",
    s3Title: "经典娱乐",
    s3Desc: "多种经典线上娱乐内容与平台资讯",
    s4Title: "最新资讯",
    s4Desc: "体育、电竞及线上娱乐最新动态",
    flowHeading: "ASG与合作平台",
    f1: "ASG内容导览",
    f2: "体育/电竞/线上娱乐内容",
    f3: "第三方合作平台",
    flowNote: "ASG提供内容整理与导览，部分内容可能连接至独立运营的第三方合作平台，相关服务、条款、年龄及地区限制以第三方平台为准。",
    platformHeading: "关于合作平台",
    platformBody1: "本站提供体育、电竞及线上娱乐相关资讯与内容导览，并可能通过联盟链接连接至第三方合作平台。第三方平台独立运营，其服务内容、使用条款、隐私政策、年龄要求及地区限制均由第三方平台自行负责。",
    beforeHeading: "访问前请了解",
    b1Title: "第三方独立运营",
    b1Desc: "本站不直接处理第三方平台账户或资金服务",
    b2Title: "地区限制",
    b2Desc: "部分服务可能无法在所有国家或地区使用",
    b3Title: "年龄要求",
    b3Desc: "仅限达到所在地法定年龄的用户",
    b4Title: "风险提示",
    b4Desc: "涉及真钱游戏或博彩服务存在资金损失风险",
    footerPrivacy: "隐私政策",
    footerTerms: "服务条款",
    footerDisclosure: "联盟披露",
    footerResponsible: "负责任游戏",
    backHome: "返回首页",
    lastUpdated: "最后更新：2026 年 9 月",
    disclaimerText: "本站为独立推广/信息页面，不直接提供博彩交易或资金服务。具体服务、活动及条款以合作平台官网为准。",
    responsible: "仅限达到所在地法定年龄的用户 · 请理性娱乐 · 涉及真钱游戏存在资金损失风险 · 请遵守所在地法律法规",
    copyright: "© 2026 亚洲体育与娱乐指南 · 独立第三方资讯页面",
  },
  "zh-TW": {
    kicker: "亞洲體育 · 電競 · 娛樂資訊",
    heroLine1: "亞洲體育",
    heroLine2: "與娛樂指南",
    heroTags: "足球 · 籃球 · 電競 · 線上娛樂",
    heroDesc: "聚合亞洲體育、電競與線上娛樂內容，快速了解近期熱門資訊與合作平台資訊。",
    valueLine: "體育 · 電競 · 娛樂內容一站了解",
    tag1: "足球 · 籃球",
    tag2: "電競動態",
    tag3: "線上娛樂",
    ctaGo: "進入娛樂平台",
    ctaHelper: "了解第三方體育與線上娛樂內容",
    ctaNote: "將前往第三方合作平台",
    regionNotice: "第三方服務可用性因地區、年齡及當地法規而異",
    valueHeading: "熱門內容",
    v1Title: "線上娛樂",
    v1Desc: "多元線上娛樂內容與最新動態",
    v2Title: "足球",
    v2Desc: "賽事資訊 · 球隊動態",
    v3Title: "籃球",
    v3Desc: "賽事資訊 · 球員動態",
    v4Title: "電競",
    v4Desc: "電競賽事 · 戰隊資訊",
    bridgeLine: "從體育賽事、電競競技到線上娛樂內容，快速了解不同內容類型，並查看相關第三方合作平台資訊。",
    seeHeading: "你可以在ASG看到什麼",
    seeSub: "從賽事動態到數字娛樂，一站了解體育、電競與線上娛樂內容。",
    scope1: "足球賽事",
    scope2: "籃球動態",
    scope3: "電競競技",
    s1Title: "賽事互動",
    s1Desc: "賽程、對陣、比賽動態與互動內容",
    s2Title: "數字競技",
    s2Desc: "電競賽事、競技內容與數字娛樂動態",
    s3Title: "經典娛樂",
    s3Desc: "多種經典線上娛樂內容與平台資訊",
    s4Title: "最新資訊",
    s4Desc: "體育、電競及線上娛樂最新動態",
    flowHeading: "ASG與合作平台",
    f1: "ASG內容導覽",
    f2: "體育/電競/線上娛樂內容",
    f3: "第三方合作平台",
    flowNote: "ASG提供內容整理與導覽，部分內容可能連接至獨立運營的第三方合作平台，相關服務、條款、年齡及地區限制以第三方平台為準。",
    platformHeading: "關於合作平台",
    platformBody1: "本站提供體育、電競及線上娛樂相關資訊與內容導覽，並可能透過聯盟連結連接至第三方合作平台。第三方平台獨立運營，其服務內容、使用條款、隱私政策、年齡要求及地區限制均由第三方平台自行負責。",
    beforeHeading: "訪問前請了解",
    b1Title: "第三方獨立運營",
    b1Desc: "本站不直接處理第三方平台帳戶或資金服務",
    b2Title: "地區限制",
    b2Desc: "部分服務可能無法在所有國家或地區使用",
    b3Title: "年齡要求",
    b3Desc: "僅限達到所在地法定年齡的用戶",
    b4Title: "風險提示",
    b4Desc: "涉及真錢遊戲或博彩服務存在資金損失風險",
    footerPrivacy: "隱私政策",
    footerTerms: "服務條款",
    footerDisclosure: "聯盟披露",
    footerResponsible: "負責任遊戲",
    backHome: "返回首頁",
    lastUpdated: "最後更新：2026 年 9 月",
    disclaimerText: "本站為獨立推廣/資訊頁面，不直接提供博彩交易或資金服務。具體服務、活動及條款以合作平台官網為準。",
    responsible: "僅限達到所在地法定年齡的用戶 · 請理性娛樂 · 涉及真錢遊戲存在資金損失風險 · 請遵守所在地法律法規",
    copyright: "© 2026 亞洲體育與娛樂指南 · 獨立第三方資訊頁面",
  },
  en: {
    kicker: "Asia Sports · Esports · Entertainment News",
    heroLine1: "Asia Sports",
    heroLine2: "& Entertainment Guide",
    heroTags: "Football · Basketball · Esports · Online Entertainment",
    heroDesc: "Asian sports, esports and online entertainment in one place — catch up on trending stories and partner platform info.",
    valueLine: "Sports · Esports · Entertainment — all in one place",
    tag1: "Football · Basketball",
    tag2: "Esports",
    tag3: "Entertainment",
    ctaGo: "Enter Entertainment Platform",
    ctaHelper: "Explore third-party sports & online entertainment content",
    ctaNote: "You will be redirected to a third-party partner platform",
    regionNotice: "Third-party service availability varies by region, age and local laws",
    valueHeading: "What We Cover",
    v1Title: "Online Entertainment",
    v1Desc: "Diverse online entertainment content and latest updates",
    v2Title: "Football",
    v2Desc: "Match coverage · Team news",
    v3Title: "Basketball",
    v3Desc: "Match coverage · Player updates",
    v4Title: "Esports",
    v4Desc: "Esports events · Team news",
    bridgeLine: "From sports events and esports to online entertainment — quickly explore content types and related third-party partner platform info.",
    seeHeading: "What You Can Explore on ASG",
    seeSub: "From match updates to digital entertainment — sports, esports and online entertainment in one place.",
    scope1: "Football",
    scope2: "Basketball",
    scope3: "Esports",
    s1Title: "Live Sports",
    s1Desc: "Schedules, fixtures, match updates and interactive content",
    s2Title: "Digital Esports",
    s2Desc: "Esports events, competitive content and digital entertainment updates",
    s3Title: "Classic Entertainment",
    s3Desc: "A variety of classic online entertainment content and platform info",
    s4Title: "Latest News",
    s4Desc: "Latest updates on sports, esports and online entertainment",
    flowHeading: "ASG & Partner Platforms",
    f1: "ASG Content Guide",
    f2: "Sports · Esports · Entertainment Content",
    f3: "Third-Party Partner Platform",
    flowNote: "ASG provides content curation and guidance. Some content may link to independently operated third-party partner platforms; their services, terms, age requirements and regional restrictions are governed by the respective platforms.",
    platformHeading: "About the Partner Platform",
    platformBody1: "This site provides sports, esports and online entertainment information and content guidance, and may connect to third-party partner platforms via affiliate links. Third-party platforms operate independently; their services, terms of use, privacy policies, age requirements and regional restrictions are their own responsibility.",
    beforeHeading: "Before You Visit",
    b1Title: "Independently Operated",
    b1Desc: "We do not handle third-party platform accounts or fund services",
    b2Title: "Regional Restrictions",
    b2Desc: "Some services may not be available in all countries or regions",
    b3Title: "Age Requirement",
    b3Desc: "Only for users of legal age in their jurisdiction",
    b4Title: "Risk Notice",
    b4Desc: "Real-money gaming or betting services carry the risk of financial loss",
    footerPrivacy: "Privacy Policy",
    footerTerms: "Terms",
    footerDisclosure: "Affiliate Disclosure",
    footerResponsible: "Responsible Gaming",
    backHome: "Back to Home",
    lastUpdated: "Last updated: September 2026",
    disclaimerText: "This is an independent promotional/information page and does not provide betting transactions or fund services. Services, promotions and terms are subject to the partner platform's official site.",
    responsible: "Only for users of legal age in their jurisdiction · Play responsibly · Real-money gaming involves risk of loss · Comply with local laws",
    copyright: "© 2026 Asia Sports & Entertainment Guide · Independent Info Page",
  },
  vi: {
    kicker: "Thể thao châu Á · Esports · Tin giải trí",
    heroLine1: "Thể Thao Châu Á",
    heroLine2: "& Giải Trí Trực Tuyến",
    heroTags: "Bóng đá · Bóng rổ · Esports · Giải trí trực tuyến",
    heroDesc: "Tổng hợp nội dung thể thao, esports và giải trí trực tuyến châu Á — cập nhật nhanh tin hot và thông tin nền tảng đối tác.",
    valueLine: "Thể thao · Esports · Giải trí — tất cả trong một",
    tag1: "Bóng đá · Bóng rổ",
    tag2: "Esports",
    tag3: "Giải Trí",
    ctaGo: "Vào Nền Tảng Giải Trí",
    ctaHelper: "Tìm hiểu nội dung thể thao & giải trí trực tuyến bên thứ ba",
    ctaNote: "Bạn sẽ được chuyển đến nền tảng đối tác bên thứ ba",
    regionNotice: "Dịch vụ bên thứ ba khả dụng tùy theo khu vực, độ tuổi và luật địa phương",
    valueHeading: "Nội Dung Nổi Bật",
    v1Title: "Giải Trí Trực Tuyến",
    v1Desc: "Nội dung giải trí trực tuyến đa dạng và tin mới nhất",
    v2Title: "Bóng Đá",
    v2Desc: "Tin sự kiện · Động thái đội bóng",
    v3Title: "Bóng Rổ",
    v3Desc: "Tin sự kiện · Động thái cầu thủ",
    v4Title: "Esports",
    v4Desc: "Giải đấu esports · Tin đội tuyển",
    bridgeLine: "Từ sự kiện thể thao, esports đến nội dung giải trí trực tuyến — khám phá nhanh các loại nội dung và thông tin nền tảng đối tác bên thứ ba liên quan.",
    seeHeading: "Bạn Có Thể Xem Gì Trên ASG",
    seeSub: "Từ tin thi đấu đến giải trí số — thể thao, esports và giải trí trực tuyến trong một nơi.",
    scope1: "Bóng Đá",
    scope2: "Bóng Rổ",
    scope3: "Esports",
    s1Title: "Tương Tác Sự Kiện",
    s1Desc: "Lịch thi đấu, cặp đối đầu, diễn biến trận đấu và nội dung tương tác",
    s2Title: "Thể Thao Điện Tử",
    s2Desc: "Giải đấu esports, nội dung thi đấu và tin giải trí số",
    s3Title: "Giải Trí Kinh Điển",
    s3Desc: "Nhiều nội dung giải trí trực tuyến kinh điển và tin nền tảng",
    s4Title: "Tin Mới Nhất",
    s4Desc: "Tin mới nhất về thể thao, esports và giải trí trực tuyến",
    flowHeading: "ASG & Nền Tảng Đối Tác",
    f1: "Cẩm Nang Nội Dung ASG",
    f2: "Nội Dung Thể Thao · Esports · Giải Trí",
    f3: "Nền Tảng Đối Tác Bên Thứ Ba",
    flowNote: "ASG cung cấp tổng hợp và dẫn hướng nội dung; một số nội dung có thể kết nối đến nền tảng đối tác bên thứ ba vận hành độc lập, dịch vụ, điều khoản, yêu cầu độ tuổi và giới hạn khu vực theo quy định của nền tảng đó.",
    platformHeading: "Về Nền Tảng Đối Tác",
    platformBody1: "Trang này cung cấp thông tin và dẫn hướng nội dung thể thao, esports và giải trí trực tuyến, và có thể kết nối đến nền tảng bên thứ ba qua liên kết tiếp thị liên kết. Nền tảng bên thứ ba vận hành độc lập; nội dung dịch vụ, điều khoản sử dụng, chính sách bảo mật, yêu cầu độ tuổi và giới hạn khu vực do nền tảng đó tự chịu trách nhiệm.",
    beforeHeading: "Trước Khi Truy Cập",
    b1Title: "Vận Hành Độc Lập",
    b1Desc: "Chúng tôi không xử lý tài khoản hay dịch vụ tài chính của nền tảng bên thứ ba",
    b2Title: "Giới Hạn Khu Vực",
    b2Desc: "Một số dịch vụ có thể không khả dụng ở mọi quốc gia hoặc khu vực",
    b3Title: "Yêu Cầu Độ Tuổi",
    b3Desc: "Chỉ dành cho người dùng đủ tuổi theo luật địa phương",
    b4Title: "Lưu Ý Rủi Ro",
    b4Desc: "Dịch vụ trò chơi tiền thật hoặc cá cược có rủi ro mất tiền",
    footerPrivacy: "Chính Sách Bảo Mật",
    footerTerms: "Điều Khoản",
    footerDisclosure: "Tiết Lộ Liên Kết",
    footerResponsible: "Chơi Có Trách Nhiệm",
    backHome: "Về Trang Chủ",
    lastUpdated: "Cập nhật lần cuối: Tháng 9/2026",
    disclaimerText: "Đây là trang thông tin/quảng bá độc lập, không cung cấp giao dịch cá cược hay dịch vụ tài chính. Dịch vụ, khuyến mãi và điều khoản theo website chính thức của nền tảng.",
    responsible: "Chỉ dành cho người dùng đủ tuổi theo luật địa phương · Chơi có trách nhiệm · Trò chơi tiền thật có rủi ro mất tiền · Tuân thủ pháp luật địa phương",
    copyright: "© 2026 Hướng Dẫn Thể Thao & Giải Trí Châu Á · Trang thông tin độc lập",
  },
  th: {
    kicker: "กีฬาเอเชีย · อีสปอร์ต · ข่าวความบันเทิง",
    heroLine1: "เอเชียสปอร์ต",
    heroLine2: "& ความบันเทิงออนไลน์",
    heroTags: "ฟุตบอล · บาสเกตบอล · อีสปอร์ต · ความบันเทิงออนไลน์",
    heroDesc: "รวมเนื้อหากีฬา อีสปอร์ต และความบันเทิงออนไลน์ของเอเชีย ติดตามข่าวยอดนิยมและข้อมูลแพลตฟอร์มพันธมิตรได้อย่างรวดเร็ว",
    valueLine: "กีฬา · อีสปอร์ต · ความบันเทิง ครบในที่เดียว",
    tag1: "ฟุตบอล · บาสเกตบอล",
    tag2: "อีสปอร์ต",
    tag3: "ความบันเทิง",
    ctaGo: "เข้าสู่แพลตฟอร์มความบันเทิง",
    ctaHelper: "เรียนรู้เนื้อหากีฬาและความบันเทิงออนไลน์จากบุคคลที่สาม",
    ctaNote: "คุณจะถูกนำไปยังแพลตฟอร์มพันธมิตรบุคคลที่สาม",
    regionNotice: "ความพร้อมใช้งานบริการบุคคลที่สามแตกต่างตามภูมิภาค อายุ และกฎหมายท้องถิ่น",
    valueHeading: "เนื้อหายอดนิยม",
    v1Title: "ความบันเทิงออนไลน์",
    v1Desc: "เนื้อหาความบันเทิงออนไลน์ที่หลากหลายและอัปเดตล่าสุด",
    v2Title: "ฟุตบอล",
    v2Desc: "ข่าวการแข่งขัน · ความเคลื่อนไหวของทีม",
    v3Title: "บาสเกตบอล",
    v3Desc: "ข่าวการแข่งขัน · ความเคลื่อนไหวของผู้เล่น",
    v4Title: "อีสปอร์ต",
    v4Desc: "การแข่งขันอีสปอร์ต · ข่าวทีม",
    bridgeLine: "จากการแข่งขันกีฬา อีสปอร์ต สู่เนื้อหาความบันเทิงออนไลน์ เรียนรู้ประเภทเนื้อหาต่าง ๆ และดูข้อมูลแพลตฟอร์มพันธมิตรบุคคลที่สามที่เกี่ยวข้อง",
    seeHeading: "สิ่งที่คุณจะได้เห็นบน ASG",
    seeSub: "จากข่าวการแข่งขันสู่ความบันเทิงดิจิทัล รวมกีฬา อีสปอร์ต และความบันเทิงออนไลน์ไว้ในที่เดียว",
    scope1: "ฟุตบอล",
    scope2: "บาสเกตบอล",
    scope3: "อีสปอร์ต",
    s1Title: "ติดตามการแข่งขัน",
    s1Desc: "ตารางแข่ง คู่แข่ง ความเคลื่อนไหว และเนื้อหาเชิงโต้ตอบ",
    s2Title: "อีสปอร์ตดิจิทัล",
    s2Desc: "ทัวร์นาเมนต์อีสปอร์ต เนื้อหาการแข่งขัน และข่าวความบันเทิงดิจิทัล",
    s3Title: "ความบันเทิงคลาสสิก",
    s3Desc: "เนื้อหาความบันเทิงออนไลน์คลาสสิกที่หลากหลายและข่าวแพลตฟอร์ม",
    s4Title: "ข่าวล่าสุด",
    s4Desc: "ข่าวล่าสุดเกี่ยวกับกีฬา อีสปอร์ต และความบันเทิงออนไลน์",
    flowHeading: "ASG กับแพลตฟอร์มพันธมิตร",
    f1: "คู่มือเนื้อหา ASG",
    f2: "เนื้อหากีฬา · อีสปอร์ต · ความบันเทิง",
    f3: "แพลตฟอร์มพันธมิตรบุคคลที่สาม",
    flowNote: "ASG ให้บริการรวบรวมและแนะนำเนื้อหา บางเนื้อหาอาจเชื่อมไปยังแพลตฟอร์มพันธมิตรบุคคลที่สามที่ดำเนินการอย่างอิสระ บริการ ข้อกำหนด ข้อกำหนดอายุ และข้อจำกัดตามภูมิภาคเป็นไปตามแพลตฟอร์มนั้น",
    platformHeading: "เกี่ยวกับแพลตฟอร์มพันธมิตร",
    platformBody1: "เว็บไซต์นี้ให้ข้อมูลและแนะนำเนื้อหากีฬา อีสปอร์ต และความบันเทิงออนไลน์ และอาจเชื่อมต่อไปยังแพลตฟอร์มบุคคลที่สามผ่านลิงก์พันธมิตร แพลตฟอร์มบุคคลที่สามดำเนินการอย่างอิสระ เนื้อหาบริการ ข้อกำหนดการใช้งาน นโยบายความเป็นส่วนตัว ข้อกำหนดอายุ และข้อจำกัดตามภูมิภาคอยู่ภายใต้ความรับผิดชอบของแพลตฟอร์มนั้น",
    beforeHeading: "สิ่งที่ควรรู้ก่อนเข้าชม",
    b1Title: "ดำเนินการอย่างอิสระ",
    b1Desc: "เราไม่ได้จัดการบัญชีหรือบริการทางการเงินของแพลตฟอร์มบุคคลที่สาม",
    b2Title: "ข้อจำกัดภูมิภาค",
    b2Desc: "บางบริการอาจไม่พร้อมใช้งานในทุกประเทศหรือภูมิภาค",
    b3Title: "ข้อกำหนดอายุ",
    b3Desc: "เฉพาะผู้ใช้ที่มีอายุถูกกฎหมายในพื้นที่ของคุณ",
    b4Title: "คำเตือนความเสี่ยง",
    b4Desc: "บริการเกมเงินจริงหรือการเดิมพันมีความเสี่ยงสูญเสียเงิน",
    footerPrivacy: "นโยบายความเป็นส่วนตัว",
    footerTerms: "ข้อกำหนด",
    footerDisclosure: "การเปิดเผยพันธมิตร",
    footerResponsible: "การเล่นอย่างรับผิดชอบ",
    backHome: "กลับหน้าแรก",
    lastUpdated: "อัปเดตล่าสุด: กันยายน 2026",
    disclaimerText: "เว็บไซต์นี้เป็นเพจข้อมูล/โปรโมชันอิสระ ไม่ได้ให้บริการเดิมพันหรือบริการทางการเงิน บริการ โปรโมชัน และเงื่อนไขเป็นไปตามเว็บไซต์อย่างเป็นทางการของแพลตฟอร์ม",
    responsible: "เฉพาะผู้ใช้ที่มีอายุถึงเกณฑ์กฎหมายในพื้นที่ของตน · เล่นอย่างมีความรับผิดชอบ · เกมเงินจริงมีความเสี่ยงสูญเสียเงิน · ปฏิบัติตามกฎหมายท้องถิ่น",
    copyright: "© 2026 คู่มือกีฬาและความบันเทิงเอเชีย · เพจข้อมูลอิสระ",
  },
  ms: {
    kicker: "Sukan Asia · Esports · Berita Hiburan",
    heroLine1: "Sukan Asia",
    heroLine2: "& Hiburan Dalam Talian",
    heroTags: "Bola Sepak · Bola Keranjang · Esports · Hiburan Dalam Talian",
    heroDesc: "Himpunan kandungan sukan, esports dan hiburan dalam talian Asia — ikuti berita popular dan info platform rakan kongsi dengan pantas.",
    valueLine: "Sukan · Esports · Hiburan — semua dalam satu tempat",
    tag1: "Bola Sepak · Bola Keranjang",
    tag2: "Esports",
    tag3: "Hiburan",
    ctaGo: "Masuk ke Platform Hiburan",
    ctaHelper: "Ketahui kandungan sukan & hiburan dalam talian pihak ketiga",
    ctaNote: "Anda akan dibawa ke platform rakan kongsi pihak ketiga",
    regionNotice: "Ketersediaan perkhidmatan pihak ketiga berbeza mengikut wilayah, umur dan undang-undang tempatan",
    valueHeading: "Kandungan Popular",
    v1Title: "Hiburan Dalam Talian",
    v1Desc: "Pelbagai kandungan hiburan dalam talian dan perkembangan terkini",
    v2Title: "Bola Sepak",
    v2Desc: "Berita perlawanan · Perkembangan pasukan",
    v3Title: "Bola Keranjang",
    v3Desc: "Berita perlawanan · Perkembangan pemain",
    v4Title: "Esports",
    v4Desc: "Kejohanan esports · Berita pasukan",
    bridgeLine: "Dari acara sukan, esports kepada kandungan hiburan dalam talian — kenali pelbagai jenis kandungan dan maklumat platform rakan kongsi pihak ketiga yang berkaitan.",
    seeHeading: "Apa Yang Boleh Anda Lihat di ASG",
    seeSub: "Dari berita perlawanan kepada hiburan digital — sukan, esports dan hiburan dalam talian dalam satu tempat.",
    scope1: "Bola Sepak",
    scope2: "Bola Keranjang",
    scope3: "Esports",
    s1Title: "Interaksi Sukan",
    s1Desc: "Jadual, perlawanan, perkembangan perlawanan dan kandungan interaktif",
    s2Title: "Esports Digital",
    s2Desc: "Kejohanan esports, kandungan pertandingan dan berita hiburan digital",
    s3Title: "Hiburan Klasik",
    s3Desc: "Pelbagai kandungan hiburan dalam talian klasik dan info platform",
    s4Title: "Berita Terkini",
    s4Desc: "Perkembangan terkini sukan, esports dan hiburan dalam talian",
    flowHeading: "ASG & Platform Rakan Kongsi",
    f1: "Panduan Kandungan ASG",
    f2: "Kandungan Sukan · Esports · Hiburan",
    f3: "Platform Rakan Kongsi Pihak Ketiga",
    flowNote: "ASG menyediakan susunan dan panduan kandungan; sesetengah kandungan mungkin menghubungkan ke platform rakan kongsi pihak ketiga yang beroperasi secara bebas, dan perkhidmatan, terma, syarat umur serta sekatan wilayah tertakluk pada platform tersebut.",
    platformHeading: "Tentang Platform Rakan Kongsi",
    platformBody1: "Laman ini menyediakan maklumat dan panduan kandungan sukan, esports serta hiburan dalam talian, dan mungkin menghubungkan ke platform pihak ketiga melalui pautan gabungan. Platform pihak ketiga beroperasi secara bebas; kandungan perkhidmatan, terma penggunaan, dasar privasi, syarat umur dan sekatan wilayah adalah tanggungjawab platform tersebut.",
    beforeHeading: "Sebelum Melawat",
    b1Title: "Beroperasi Secara Bebas",
    b1Desc: "Kami tidak menguruskan akaun atau perkhidmatan kewangan platform pihak ketiga",
    b2Title: "Sekatan Wilayah",
    b2Desc: "Sesetengah perkhidmatan mungkin tidak tersedia di semua negara atau wilayah",
    b3Title: "Syarat Umur",
    b3Desc: "Hanya untuk pengguna yang mencapai umur sah di wilayah anda",
    b4Title: "Notis Risiko",
    b4Desc: "Perkhidmatan permainan wang sebenar atau pertaruhan membawa risiko kerugian wang",
    footerPrivacy: "Dasar Privasi",
    footerTerms: "Terma",
    footerDisclosure: "Pendedahan Gabungan",
    footerResponsible: "Permainan Bertanggungjawab",
    backHome: "Kembali ke Laman Utama",
    lastUpdated: "Kemas kini terakhir: September 2026",
    disclaimerText: "Laman ini adalah halaman maklumat/promosi bebas dan tidak menyediakan transaksi pertaruhan atau perkhidmatan kewangan. Perkhidmatan, promosi dan terma tertakluk pada laman rasmi platform.",
    responsible: "Hanya untuk pengguna yang mencapai umur sah di wilayah anda · Main dengan bertanggungjawab · Permainan wang sebenar membawa risiko kerugian wang · Patuhi undang-undang tempatan",
    copyright: "© 2026 Panduan Sukan & Hiburan Asia · Halaman maklumat bebas",
  },
};
